import React ,{Component }from 'react'
import './NavigationHeader.css';
import { Link,NavLink } from 'react-router-dom';
class NavIgationHeader extends Component {
          constructor(props) {
            super(props)          
            this.state = {
              
            }
            
          }
          
          render(){
           return(
            <ul>
            <li><Link to="/">Personal Detail</Link></li>
            <li><NavLink to="/TechSkill" activeClassName="Link-active">Technical Skills</NavLink></li>
            <li><NavLink to="/Experience" activeClassName="Link-active" >Experience</NavLink></li>
            <li><NavLink to="/ContactInformation" activeClassName="Link-active">ContactMe</NavLink></li>
            <li><NavLink to="/Aboutme" activeClassName="Link-active">AboutMe</NavLink></li>
            <li><NavLink to="/Personal" activeClassName="Link-active">Personal</NavLink> </li>  
            {  (this.props.MenuItem === true) ? 
            <li style={{float:'right'}}><NavLink to="/Login" activeClassName="Link-active">Login</NavLink> </li>   :
            <li style={{float:'right'}}><NavLink to="/Logout" activeClassName="Link-active">Logout</NavLink> </li> 
            }
            </ul>        
           )
          }
        
        }
export default NavIgationHeader
